import { z } from "zod";

export const PermissionSchema = z.object({
    name: z.string().nonempty(),
    group: z.string().nonempty(),
});

export type PermissionForm = z.infer<typeof PermissionSchema>;